import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NotFoundPageTexts } from '../../../core/models/library-text-translations.model';

@Component({
  selector: 'lib-page-not-found-404',
  imports: [RouterLink],
  standalone: true,
  templateUrl: './page-not-found-404.component.html',
  styleUrl: './page-not-found-404.component.scss',
})
export class PageNotFound404Component {
  readonly notFoundPageTexts =
    input.required<Record<NotFoundPageTexts, string>>();
}
